module.exports = __webpack_public_path__ + "img/lazada.b26c4983.jpg";